// Javelin (Mars): a constellation that is one unbroken line of stars, with
// only its two ends as branches, scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { branches } from '../shared/branches';
import type { AlignmentDef } from '../types';

export const javelin: AlignmentDef = {
  id: 'javelin',
  planet: 'mars',
  name: 'Javelin',
  text: () => `Constellations with only ${N.javelinBranches === 2 ? 'two' : N.javelinBranches} branches score +${N.javelinPercent}%.`,
  wordPercent: (c) => (branches(c) === N.javelinBranches ? N.javelinPercent : 0),
};
